import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GwcApiConnService } from './gwc-api-conn.service';

@Injectable({
	providedIn: 'root'
})
export class GwcApiCasualOrdersService  {

	constructor(
		private _gwcApiConnService: GwcApiConnService
	) { }


	public postCasualOrder(data: any) {
		return this._gwcApiConnService.request('POST', 'CasualOrder', null, data) as Observable<any>
	}
	
	public postProcessPayment(casual_order_id: string, payload: any) {
		return this._gwcApiConnService.request('POST', ['CasualOrder', casual_order_id, 'processPayment'], null, payload)
	}	

	public postConfirmOrder(casual_order_id: string) {
		return this._gwcApiConnService.request('POST', ['CasualOrder', casual_order_id, 'confirmOrder']);
	}


}
